import React, { useState } from "react";
import "./OrgChart.scss";

const OrgChart = ({
  data = [],
  colors = {},
  expandAll = false,
  onNodeClick = () => {},
}) => {
  const [expandedNodes, setExpandedNodes] = useState(
    new Set(
      expandAll
        ? data.map((item) => item.id)
        : data.filter((item) => item.level === 0).map((item) => item.id)
    )
  );

  const toggleNode = (nodeId) => {
    const newExpanded = new Set(expandedNodes);
    if (newExpanded.has(nodeId)) {
      newExpanded.delete(nodeId);
    } else {
      newExpanded.add(nodeId);
    }
    setExpandedNodes(newExpanded);
  };

  const getChildren = (parentId) => {
    return data.filter((item) => item.parentId === parentId);
  };

  const buildHierarchy = () => {
    const hierarchy = {};
    data.forEach((item) => {
      if (item.parentId === null) {
        hierarchy[item.id] = { ...item, children: [] };
      }
    });

    const addChildren = (parentId) => {
      const children = getChildren(parentId);
      return children.map((child) => ({
        ...child,
        children: addChildren(child.id),
      }));
    };

    Object.keys(hierarchy).forEach((rootId) => {
      hierarchy[rootId].children = addChildren(parseInt(rootId));
    });

    return Object.values(hierarchy);
  };

  const EmployeeNode = ({ employee }) => {
    const children = getChildren(employee.id);
    const hasChildren = children.length > 0;
    const isExpanded = expandedNodes.has(employee.id);
    const nodeColor =
      colors[employee.department] || colors.default || "#f3f4f6";

    return (
      <div className="org-node-container">
        <div
          className="org-node-card"
          style={{ backgroundColor: nodeColor }}
          onClick={() => onNodeClick(employee)}
        >
          <div className="org-avatar">{employee.avatar || "👤"}</div>

          <div className="org-info">
            <h4 className="org-name" title={employee.name}>
              {employee.name}
            </h4>
            <p className="org-title" title={employee.title}>
              {employee.title}
            </p>
            <p className="org-department">{employee.department}</p>
          </div>

          {hasChildren && (
            <button
              className="org-expand-button-bottom"
              onClick={(e) => {
                e.stopPropagation();
                toggleNode(employee.id);
              }}
            >
              {isExpanded ? (
                <i className="fas fa-chevron-up"></i>
              ) : (
                <i className="fas fa-chevron-down"></i>
              )}
            </button>
          )}

          {hasChildren && (
            <div className="org-count-badge">{children.length}</div>
          )}
        </div>

        {hasChildren && isExpanded && (
          <div className="org-children-container">
            <div className="org-line-vertical"></div>

            {children.length > 1 && (
              <div className="org-line-horizontal"></div>
            )}

            <div className="org-children-grid">
              {children.map((child) => (
                <div key={child.id} className="org-child-wrapper">
                  <div className="org-line-child"></div>
                  <EmployeeNode employee={child} />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="org-chart-container">
      <div className="org-chart-wrapper">
        {buildHierarchy().map((rootEmployee) => (
          <EmployeeNode key={rootEmployee.id} employee={rootEmployee} />
        ))}
      </div>
    </div>
  );
};

export default OrgChart;
